var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"marketing-category-card",style:({
    'background-image': ("url(" + _vm.backgroundImageUrl + ")"),
    'background-size': 'cover',
  }),on:{"click":function($event){return _vm.$emit('input', _vm.type)}}},[_c('div',{staticClass:"qrw-heading-xs",class:{
      'v1-grey-3-color': _vm.isSelected,
      'v1-grey-10-color': !_vm.isSelected,
    }},[_vm._v("\n    "+_vm._s(_vm.$t("marketing.tab_" + _vm.type))+"\n  ")]),_c('div',{staticClass:"qrw-paragraph-xs mt-8",class:{
      'v1-grey-7-color': !_vm.isSelected,
      'v1-grey-6-color': _vm.isSelected,
    }},[_vm._v("\n    "+_vm._s(_vm.$t("marketing.desc_" + _vm.type))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }